import React from 'react';
import { Reveal } from '../components/Reveal';
import { Ban, Landmark, BookOpenCheck, Lock, ScrollText } from 'lucide-react';

/**
 * Marketing ruling M1 (2026-10-20): facts only, and each one links to the
 * part of the page that describes the thing it names.
 */
const signals = [
  { icon: Ban, label: 'Long-only, no borrowing', href: '#what-it-holds' },
  { icon: Landmark, label: 'Paper account at Alpaca (US stocks, ETFs, crypto)', href: '#pricing' },
  { icon: BookOpenCheck, label: 'Rules are written down and tested before the AI may review them', href: '#what-it-holds' },
  { icon: Lock, label: 'Limits enforced by code outside the AI', href: '#how-it-works' },
  { icon: ScrollText, label: 'Every action recorded', href: '#proof' },
];

export const TrustBar: React.FC = () => {
  return (
    <section className="py-10 px-6 border-b border-white/[0.04]">
      <Reveal
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-[1000px] mx-auto flex flex-wrap justify-center gap-x-10 gap-y-4"
      >
        {signals.map((s) => (
          <a
            key={s.label}
            href={s.href}
            className="flex items-center gap-2 text-white/30 text-sm hover:text-white/60 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2dd4a0] rounded-sm"
          >
            <s.icon size={14} className="text-white/20" />
            {s.label}
          </a>
        ))}
      </Reveal>
    </section>
  );
};
